import { render, staticRenderFns } from "./UploadMultipleFiles.vue?vue&type=template&id=1888da96&"
import script from "./UploadMultipleFiles.vue?vue&type=script&lang=js&"
export * from "./UploadMultipleFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1888da96')) {
      api.createRecord('1888da96', component.options)
    } else {
      api.reload('1888da96', component.options)
    }
    module.hot.accept("./UploadMultipleFiles.vue?vue&type=template&id=1888da96&", function () {
      api.rerender('1888da96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/_vue/componentes/UploadMultipleFiles.vue"
export default component.exports